import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { StatsigProvider } from '@statsig/react-bindings';

import { Error, Layout, numeratorInsightsLogoImage as NumeratorInsightsLogo } from '@utilities';

import { readReportPublicToken } from '@api/reports';
import { readSurveyPublicToken } from '@api/surveys';
import { readFlowPublicToken } from '@api/narratives';
import { setInstantSurveyAuthToken } from '../../utilities/api/instant_survey/api';

import Footer from '../../components/Footer';
import Page from '@src/app/pages/Dashboard/layouts/Page';
import { Report } from '@src/app/pages/Dashboard/pages/Report';
import { Survey } from '@src/app/pages/Dashboard/pages/Survey';
import { Narrative } from '@src/app/pages/Dashboard/pages/Narrative';

import styles from './_index.module.scss';

const Share = ({ type = 'report' }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  const { token } = useParams();

  useEffect(() => {
    const getData = async () => {
      let response;
      try {
        if (type === 'report') {
          response = await readReportPublicToken({ publicToken: token });
          if (response) {
            setData(response?.data);
            return;
          }
        } else if (type === 'survey') {
          response = await readSurveyPublicToken({ publicToken: token });
          if (response) {
            setInstantSurveyAuthToken(response?.data?.serviceToken);
            setData({
              atlasInstantSurveyRef: response?.data?.atlasInstantSurveyRef,
              id: response?.data?.surveyId,
              instantSurveyTypeId: response?.data?.instantSurveyTypeId,
            });
            return;
          }
        } else if (type === 'narrative') {
          response = await readFlowPublicToken({ publicToken: token });
          if (response) {
            setData(response?.data);
            return;
          }
        }
      } catch (error) {
        console.error(error);
        setError(error);
      }
    };

    getData();
  }, [token, type]);

  if (error) return <Error status={error?.response?.status} />;

  if (!data) return null;

  return (
    <div className={styles['share']}>
      <main>
        <Page>
          <Layout.Column>
            <NumeratorInsightsLogo
              aria-label="Numerator Logo"
              className={styles['share-logo']}
              data-testid="share-logo"
              role="img"
            />
            {type === 'survey' ? (
              <StatsigProvider
                options={{
                  environment: { tier: import.meta.env.VITE_ENVIRONMENT },
                }}
                sdkKey={import.meta.env.VITE_STATSIG}
                user={{
                  userID: 'public_share',
                }}
              >
                <Survey data={data} publicToken={token} />
              </StatsigProvider>
            ) : type === 'narrative' ? (
              <Narrative id={data} publicToken={token} />
            ) : (
              <Report id={data} publicToken={token} />
            )}
          </Layout.Column>
        </Page>
      </main>
      <Footer />
    </div>
  );
};

Share.propTypes = {
  type: PropTypes.string,
};

export default Share;
